import consumer from "./consumer";

// Single subscription point for the online classroom room stream. Incoming Mural
// recados are re-dispatched as a DOM event so the classroom-mural Stimulus
// controller can render them, regardless of which view subscribed.
export default class {
  static init(roomName) {
    if (this.cable) return this.cable;

    this.cable = consumer.subscriptions.create(
      { channel: 'OnlineClassroomChannel', room_name: roomName },
      {
        received: (data) => {
          document.dispatchEvent(new CustomEvent('classroom:message', { detail: data }));
        }
      }
    );

    return this.cable;
  }
}
